module.exports = "/assets/f2ac7f3b24506156c5ce4e9082596929.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SQ.png
// module id = 2951
// module chunks = 0